<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        lg="6">
        <Item 
          v-for="item in cartItems"
          :key=item.id
          :item="item"
          @OPEN_DIALOG="startConfirmProcess"
        ></Item>
      </v-col>
    </v-row>
    
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        lg="6"
        class="text-right">
        <h2>TOTAL : {{ totalCart | toPrice(2, '€ HT') }}</h2>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        lg="6"
      >
        <v-textarea
          outlined
          v-model="comments"
          label="Commentaires"
        ></v-textarea>
      </v-col>
    </v-row>
    
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        lg="3"
      >
        <v-text-field
          v-model="customID"
          label="Votre numéro de commande (facultatif)"
          clearable
          clear-icon="mdi-close-circle-outline"
          class="pt-0"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="10"
        lg="3"
        class="text-right">
        <v-btn 
          color="success"
          :disabled="buttonClicked"
          @click="confirmCart()"
          v-if="cartQty > 0 && !showReloadButton"
        >
          <v-icon right dark class="mr-2">mdi-check</v-icon>
          Valider mon panier
        </v-btn>
        <v-btn 
          color="primary"
          @click="$router.go()"
          v-if="showReloadButton"
        >
          <v-icon right dark class="mr-2">mdi-refresh</v-icon>
          Rafraîchir la page
        </v-btn>
      </v-col>
    </v-row>
    <Dialog
      :show="showDialog"
      :item="pendingItem"
      @CLOSE_DIALOG="showDialog = false"
    ></Dialog>
  </v-container>
</template>

<script>
  // COMPONENTS
  import Dialog from './Dialog'
  import Item from './Item'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { CART_CONFIRM, STORE_OLD_CART, OPEN_DIALOG, CLOSE_DIALOG, RESET_CART_ITEMS, UPDATE_CART } from '@/store/actions/cart'
  import { SET_SNACK } from '@/store/actions/snackbar'
  import { LOADING, LOADED } from '@/store/actions/general'
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  // VUEX
  import { mapGetters } from 'vuex'

  export default {
    name: 'Checkout',
    
    components: { Item, Dialog },

    data: () => ({
      customID: null,
      comments: '',
      showDialog: false,
      pendingItem: {},
      orderSuccess: false,
      buttonClicked: false,
      showReloadButton: false,
    }),

    watch: {
      cartQty(newValue) {
        if (newValue === 0 && !this.orderSuccess) this.$router.push({ name: 'ListReference' })
      }
    },

    computed: {
      ...mapGetters({
        cartQty: 'cartQty',
        cartItems: 'getItems',
        totalCart: 'getCartTotal',
      }),
    },

    methods: {
      confirmCart() {
        const store = this.$store
        this.buttonClicked = true
        EventBus.$emit(LOADING, 'Enregistrement de la commande...')
        const { customID, comments } = this
        store
          .dispatch(STORE_OLD_CART)
          .then(() => {
            store.dispatch(CART_CONFIRM, { 
              customID: customID, 
              comments: comments, 
            }).then((orderID) => {
              if (!Number.isInteger(orderID)) {
                this.$store.commit(SET_SNACK, {
                  message: 'Une erreur est survenue lors de la validation de votre commande',
                  color: 'error'
                })
                EventBus.$emit(LOADED)
                
                return
              }
              this.orderSuccess = true             
              store
                .dispatch(RESET_CART_ITEMS)
                .then(() => {
                  EventBus.$emit(LOADED)
                  this.$router.push({
                    name: 'ShowOrder',
                    params: {
                      id: orderID,
                      referer: 'checkout',
                    },
                  })
                })
            }).catch(error => {
              EventBus.$emit(LOADED)
              if (error.response) {
                switch (error.response.status) {
                  case 403:
                    this.$store.dispatch(AUTH_LOGOUT)
                      .then(() => {
                        this.$router.push('/login')
                      })
                    break
                  case 500:
                    this.$store.commit(SET_SNACK, {
                      message: 'Une erreur est survenue lors de la validation de votre commande',
                      color: 'error'
                    })
                    EventBus.$emit(LOADED)
                    this.showReloadButton = true
                    break
                }
              }
            })
          })
          
      },
      startConfirmProcess(item) {
        this.pendingItem = item
        this.showDialog  = true
      },
    },

    mounted() {
      this.$store.dispatch(UPDATE_CART, {
        token: this.$store.getters.getAuthToken,
        customer: this.$store.getters.getCustomer
      })
    }
  }
</script>